import { getHeroByIds } from '../../services/hero.service'

export const getMainHero = async id => {
    const heroes = await getHeroByIds([id, ConvertToCrystalValeHeroId(id), ConvertToSerendale2HeroId(id)])
    if (!heroes.length) return null
    return heroes
}

export const ConvertToCrystalValeHeroId = heroId => `${'1000000000000'.slice(0, 13 - heroId.length)}${heroId}`

export const ConvertToSerendale2HeroId = heroId => `${'2000000000000'.slice(0, 13 - heroId.length)}${heroId}`
